/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react'
import { Link } from "react-router-dom";
import domic from "../images/male-social-worker-taking-care-old-woman.jpg"
//import Hero from '../components/Hero';
//import paliat from '../images/2151231518.jpg'
import respite from '../images/2151231518.jpg'
import supported from '../images/2151231524.jpg'


// Create an array of Carousel Items



/* const items = Array(5)
	.fill('')
	images.map((_, index) => ({
	alt: 'A random photo',
	image: _.image1,
	content: (
		<div>
		<strong>Round Carousel</strong>
		<span>Slide number {index + 1}</span>
		</div>
	)
	})); */

function Home() {

   // const carouselRef = React.createRef();

  return (
    <div className='relative w-full bg-cover bg-center bg-no-repeat bg-hero_pattern  md:justify-center bg-gray-50 md:bg-gray-100 bg-blend-multiply mb-5'>
 {/* 'bluetheme':'rgb(245 208 254)', */}
        {/* <Helmet>
            <title>Home </title>
            <meta name="description" content=" Enroute Care Ltd, the home of love and care."/>
            <link rel="canonical" href="/" />
        </Helmet> */}
       <section className=''>
        <section class=" ">


<section class="bg-center bg-no-repeat bg-transparent pt-8 bg-gray-800 bg-blend-multiply">

    <div class="md:px-8 mx-auto max-w-screen-2xl text-center py-12 pt-16 lg:py-24">
        <h1 class=" mb-4 text-3xl font-extrabold tracking-tight leading-none text-darkbluetheme md:text-5xl lg:text-6xl">Step-by-Step Support Ltd:</h1>
        <p class="mb-8 text-lg font-normal text-darkbluetheme lg:text-xl sm:px-16 lg:px-48">Provides different activities and services that our loved ones may enjoy and benefit from .</p>
        <div class="flex flex-col space-y-2 sm:flex-row sm:justify-center sm:space-y-0">
          
        </div>
    </div>
</section>


<div class="mx-auto lg:flex grid  lg:grid-cols-3 lg:gap-x-3 m-auto md:grid-cols-2 md:gap-x-2 grid-col-1 px-2 item-stretch ">

<div class="box-container px-4 mx-auto lg:grid  lg:grid-cols-4 lg:gap-x-2  md:grid-cols-2 md:gap-x-2 grid-col-1  item-stretch">
	<div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg">
    <div class="flip-box">
      <div class="flip-box-front  bg-doctor bg-gray-400 bg-blend-multiply bg-opacity-60 " /* style={{backgroundImage: doctor}} */>
        <div class="inner mb-1 text-white font-bold brightness-100  color-white">
          <h3 class="flip-box-header text-xl text-white">Camping</h3>
         {/*  <p>the home of quality care.</p> */}
         
        </div>
      </div>
      
    </div>
	</div>
	<div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg">
    <div class="flip-box">
      <div class="flip-box-front  bg-hands bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: hands}} */ >
        <div class="inner text-white font-bold color-white">
          <h3 class="flip-box-header text-xl">Walks </h3>
          {/* <p>where everyone matters</p> */}
          
        </div>
      </div>
      
    </div>
	</div>
	<div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg">
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-hands1 bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Learning</h3>
         {/*  <p>monitors everyone's health.</p> */}
         
        </div>
      </div>
     
    </div>
	</div>
  <div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg " >
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-garden bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Gardening</h3>
          {/* <p>monitors everyone's health.</p> */}
          
        </div>
      </div>
     
    </div>
	</div>

  <div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg " >
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-cycling bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Cycling</h3>
          {/* <p>monitors everyone's health.</p> */}
          
        </div>
      </div>
     
    </div>
	</div>

  <div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg " >
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-hiking bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Hiking</h3>
          {/* <p>monitors everyone's health.</p> */}
          
        </div>
      </div>
     
    </div>
	</div>

  <div class="box-item shadow-2xl border-2 border-lime-800 rounded-lg " >
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-fishing bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Fishing</h3>
          {/* <p>monitors everyone's health.</p> */}
          
        </div>
      </div>
     
    </div>
	</div>

  <div class="box-item drop-shadow-2xl border-2 border-lime-800 rounded-lg " >
    <div class="flip-box">
      <div class="flip-box-front font-bold bg-sports bg-gray-400 bg-blend-multiply" /* style={{backgroundImage: closesupport}} */>
        <div class="inner text-white color-white">
          <h3 class="flip-box-header text-xl">Sports</h3>
          {/* <p>monitors everyone's health.</p> */}
          
        </div>
      </div>
     
    </div>
	</div>
</div>
</div>
</section>
    
        </section>
        {/* <div className=' text-center italic text-xs'><a  href=' https://www.pexels.com/video/a-woman-instructing-the-elderly-man-to-the-medicine-7517699/'>  Video by Kampus Production</a></div> */}
{/* 
        <section class="container bg-cover bg-center bg-no-repeat bg-hero_pattern bg-gray-400 bg-blend-multiply ">
            <Hero/>
        </section> */}
        <section className=' pb-8'>
            <div class=" px-4 mx-auto max-w-screen-xl text-center pt-4">

                <div class="px-4 mx-auto max-w-screen-xl text-center pt-6 flex ">
                    <h4 class="md:mb-4 text-2xl font-extrabold tracking-tight leading-none text-navcolour md:text-3xl lg:text-3xl">
                        The services we offer include:
                    </h4>

                    {/* <div className="mb-4 rounded-lg overflow-hidden sm:w-16 lg:mt-0 mt-0 sm:mt-0">
                        <img src={serv} alt="Residential Care" className="w-full lg:h-full h-12 object-cover" />
                    </div> */}
                </div> 

                <div class=" lg:flex grid  lg:grid-cols-2 lg:gap-x-3 m-auto md:grid-cols-2 md:gap-x-2 grid-col-1 px-2 item-stretch ">

                    <div className=" shadow-2xl transition ease-in-out delay-150 hover:-translate-y-1 hover:translate-x-6 hover:scale-110 duration-300 hover:bg-cards col-span-1 rounded-lg bg-bluetheme  md:w-1/2 mt-8 sm:items-center sm:justify-center">
                        <img class="rounded-lg" src={domic} alt="old man sitting on a wheelchair" />
                        <h5 className="md:text-2xl text-lg font-bold tracking-tight text-titleblue dark:text-white pt-2">
                            <p>
                            Domiciliary Care
                            </p>
                        </h5>
                        <p className=" text-base md:text-base text-darkbluetheme dark:text-blue-500 pt-4">
                            <p class='mx-2 text-justify'>
                                We help people maintain their quality of life and independence by providing a  
                                helping hand with household chores, personal care, medication or a companionship visit

                        
                            </p>

                            <Link to="services" 
                                class="inline-flex justify-center hover:text-gray-900 items-center mt-2 md:py-3 md:mt-3 py-2 px-5 text-white font-medium text-sm md:text-lg text-center
                                text-blue rounded-lg border border-green hover:bg-green-300 focus:ring-4 focus:ring-green-400  bg-green-400 ">
                                    Learn more
                                </Link>
                        </p>
                    </div>
                    

                    {/* <div className="shadow-xl transition ease-in-out delay-150 hover:-translate-y-1 hover:translate-x-6  hover:scale-110 duration-300 hover:bg-cards col-span-1 rounded-lg bg-bluetheme lg:w-1/2 md:w-1/2 mt-8 sm:items-center sm:justify-center">
                    
                        <img class="rounded-lg" src={paliat} alt="end of life care of a man with terminal illness" />
                        <h5 className="md:text-2xl text-lg font-bold tracking-tight text-titleblue dark:text-white pt-2">
                            <p>
                            End-of-life Care
                            </p>
                        </h5>
                        <p className="font-normal text-sm md:text-lg text-darkbluetheme dark:text-gray-400 pt-4">
                            <p class='text-left'>
                            We provide physical, emotional, social, and spiritual support for patients and their families 
                            during defining moments of life.
                            </p>

                            <Link to="services" 
                                class="inline-flex justify-center hover:text-gray-900 items-center mt-2 md:py-3 md:mt-10 py-2 px-5 text-white font-medium text-sm md:text-lg text-center
                                text-blue rounded-lg border border-green hover:bg-green-300 focus:ring-4 focus:ring-green-400  bg-green-400 ">
                                    Learn more
                            </Link>
                        </p>
                        
                    </div> */}
                
                    <div className="shadow-xl transition ease-in-out delay-150 hover:-translate-y-1 hover:translate-x-6 hover:scale-110 duration-300 hover:bg-cards col-span-1 lg:w-1/2 rounded-lg bg-bluetheme md:w-1/3 mt-8 sm:items-center sm:justify-center">
                        <img class="rounded-t-lg" src={respite} alt="young-doctor-helping-one-guy-stand-up" />
                        <h5 className="md:text-2xl text-lg font-bold tracking-tight text-titleblue dark:text-white pt-2">
                            <p>
                            Respite Care
                            </p>
                        </h5>
                        <p className="font-normal text-base md:text-base text-darkbluetheme dark:text-gray-400 pt-4">
                            <p class='mx-2 text-justify'>
                                We help family members get some relief in order to re-energise at peace by providing
                                temporary care services to their loved ones being looked after.
                           
                            </p>

                            <Link to="services" 
                                class="inline-flex justify-center hover:text-gray-900 items-center mt-2 md:py-3 md:mt-3 py-2 px-5 text-white font-medium text-sm md:text-lg text-center
                                text-blue rounded-lg border border-green hover:bg-green-300 focus:ring-4 focus:ring-green-400  bg-green-400 ">
                                    Learn more
                            </Link>
                        </p>
                    </div>

                    <div className="shadow-xl transition ease-in-out delay-150 hover:-translate-y-1 hover:translate-x-6 hover:scale-110 duration-300 hover:bg-cards col-span-1 rounded-lg bg-bluetheme lg:w-1/2 md:w-1/3 mt-8 sm:items-center sm:justify-center">
                        <img class="rounded-t-lg" src={supported} alt="male-social-worker-taking-care-old-woman" />
                        <h5 className="md:text-2xl text-lg font-bold tracking-tight text-titleblue dark:text-white pt-2">
                            <p >
                            Supported Living
                            </p>
                        </h5>
                        <p className="font-normal text-base md:text-base text-darkbluetheme dark:text-gray-400 pt-4">
                            <p class='mx-2 text-justify'>
                            Our Supported Living services enable people to live independently and manage their own tenancies, with support 
                            designed around their needs and goals.
                            </p>

                            <Link to="services" 
                                 class="inline-flex justify-center hover:text-gray-900 items-center mt-2 md:py-3 md:mt-3 py-2 px-5 text-white font-medium text-sm md:text-lg text-center
                                 text-blue rounded-lg border border-green hover:bg-green-300 focus:ring-4 focus:ring-green-400  bg-green-400 ">
                                     Learn more
                                </Link>
                        </p>
                    </div>

                </div>
            </div>

        </section>
 
    </div>
  )
}

export default Home